
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { faMessageExclamation, faTextSize } from '@delfi.lt/fa-kit/icons/modules/classic/light';

interface Props {
  article: ArticleData;
}

interface Data {
  title: string | null;
}

interface Methods {
  setFontSize: () => void;
  toggleReportModal: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
      faMessageExclamation,
      faTextSize,
    };
  },
  methods: {
    setFontSize() {
      this.$event.send('link-click', { name: this.$t('article.info_decorators.enlarge'), type: `article-info-decorators` });
      this.$emit('set-font-size');
    },
    toggleReportModal() {
      this.$event.send('link-click', { name: this.$t('article.info_decorators.report_mistake'), type: `article-info-decorators` });
      this.$store.commit('article/toggleMistakeReport');

      return true;
    },
  },
});
